import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  Toolbar,
  Alert,
  ListItemText,
  Backdrop,
  CircularProgress,
  Box,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Typography,
  List,
  ListItem,
  Dialog,
  DialogContent,
  Radio,
  //RadioGroup,
  Paper,
  Divider,
} from "@mui/material";
import {
  DoDisturbOnOutlined,
  CreditCard,
  // Payment
} from "@mui/icons-material";
import axios from "axios";
import Moment from "moment";

import StripePaymentForm from "./StripePaymentForm";
import FrequentQuestions from "../Dialog/FrequentQuestions";

import checkbox from "assets/img/checkbox.jpeg";
import logo from "assets/img/logo.png";
import typeCard from "assets/img/marcas-tarjetas.png";
import errorImg from "assets/img/error.png";
import successImg from "assets/img/success.gif";
import pendingImg from "assets/img/pending.png";
import loaderGif from "assets/img/loading.gif";

import {
  AppBarStyle,
  cardBodyStyle,
  ButtonStyle0,
  blackColor,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Componente para mostrar cada método de pago
const PaymentMethodOption = ({ method, selected, onSelect }) => {
  return (
    <Paper
      elevation={selected ? 2 : 0}
      sx={{
        p: 2,
        border: selected ? "2px solid #1976d2" : "1px solid #ddd",
        borderRadius: 2,
        cursor: "pointer",
        backgroundColor: selected ? "#f0f8ff" : "white",
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
        mb: 1,
      }}
      onClick={() => onSelect(method.id)}
    >
      <Box sx={{ display: "flex" }}>
        <Radio
          checked={selected}
          onChange={() => onSelect(method.id)}
          value={method.id}
          name="payment-method"
        />
        <Box sx={{ ml: 2, display: "flex", textAlign: "left", flex: 1 }}>
          <Box sx={{ mr: 2 }}>{method.icon}</Box>
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              sx={{ color: "#000" }}
            >
              {method.name}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ color: "#000" }}
            >
              {method.description}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default function Payment(props) {
  const classes = useStyles();

  const [paymentTransactionStripe, setPaymentTransactionStripe] =
    useState(null);
  const [OpenPay, setOpenPay] = useState(false);
  const [accept, setAccept] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rows, setRows] = useState(null);
  const [Loader, setLoader] = useState(true);
  const [state, setState] = React.useState({
    YES_termsConditions: false,
    YES_dataProtectionPolicies: false,
  });
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
    img: "",
  });
  const [openFrequentQuestion, setOpenFrequentQuestion] = useState(false);
  const [disabledPay, setDisabledPay] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = useState("stripe"); // Stripe por defecto
  const [showStripeForm, setShowStripeForm] = useState(false);
  const [stripeClientSecret, setStripeClientSecret] = useState("");
  const [stripeLoading, setStripeLoading] = useState(false);

  const { urlServices, LightboxPlaceToPay } = useContext(UrlServicesContext);

  const { id } = useParams();

  // Métodos de pago disponibles
  const paymentMethods = [
    {
      id: "stripe",
      name: "Stripe",
      description: "Paga con tarjetas de crédito de forma segura",
      icon: <CreditCard sx={{ fontSize: 30, color: "#635bff" }} />,
    },
    /*{
      id: "placetopay",
      name: "PlaceToPay",
      description: "Paga con tarjetas débito, crédito o transferencias",
      icon: <Payment sx={{ fontSize: 30, color: "#1976d2" }} />,
    },*/
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RowsDatas();
  }, []);

  // Cargar el script del Lightbox en el componente
  useEffect(() => {
    const script = document.createElement("script");
    script.src = LightboxPlaceToPay;
    script.async = true;
    document.body.appendChild(script);

    // Limpiar el script al desmontar el componente
    return () => {
      document.body.removeChild(script);
    };
  }, [disabledPay]);

  const RowsDatas = async () => {
    setLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}payment-link/transaction/${id}`
      );

      if (response.status === 200) {
        const payment = response.data.data.paymentTransactions.some(
          (transaction) => transaction.status === 1
        );

        if (!payment) {
          let paymentInfo = response.data.data.paymentTransactions.some(
            (transaction) => transaction.status === 3
          );

          if (paymentInfo) {
            let paymentInfoData = response.data.data.paymentTransactions.find(
              (transaction) => transaction.status === 3
            );
            setError(true);
            setMensageSystem(
              `Esta transacción está aún en estado PENDIENTE. ref: ${paymentInfoData.reference}`
            );
          } else {
            setRows(response.data.data);
            setAccept(response.data.data.acceptTerms ? true : false);
          }
        } else {
          setError(true);
          setMensageSystem("No hay registros para mostrar.");
        }
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setMensageSystem("Registro no encontrado.");
        setError(true);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  const submitAcceptSave = (data, value) => {
    const dataValue = {
      [data]: value,
    };

    axios
      .put(`${urlServices}payment-link/web/${rows.id}`, dataValue)
      .then((response) => {})
      .catch((e) => {
        console.log(e);
      });
  };

  function getDataValue() {
    return {
      document: rows.documentId,
      documentType: rows.typeDocument,
      name: rows.name,
      surname: rows.lastName,
      email: rows.email,
      mobile: `${rows.phone}`,
      subTotal: rows.subTotal,
      iva: rows.iva,
      ivaTotal: rows.ivaSubtotal,
      payTotal: rows.total,
      paymentLinkId: rows.id,
      clientHost: rows.client.companyName,
      clientEmailHost: rows.client.email,
    };
  }

  const createPay = () => {
    setDisabledPay(true);
    const dataValue = getDataValue();

    axios
      .post(`${urlServices}placetopay/create-pay`, dataValue)
      .then((response) => {
        openLightbox(response.data);
      })
      .catch((error) => {
        setDisabledPay(false);
        handleError(error);
      });
  };

  // Función para abrir el Lightbox
  const openLightbox = (valuesData) => {
    if (window.P) {
      window.P.on("response", function (response) {
        submitRequestPay(valuesData.paymentTransaction);
      });

      // Iniciar el Lightbox
      window.P.init(valuesData.data.processUrl);
    }
  };

  const submitRequestPay = async (paymentTransaction) => {
    try {
      setOpenPay(true);
      setLoader(true);

      const response = await axios.post(
        `${urlServices}placetopay/view-pay/${paymentTransaction.requestIdTransaction}`
      );
      if (response.status === 201) {
        const status = response.data.data.status;
        if (status.status === "REJECTED") {
          setAlert({
            openAlert: true,
            errorAlert: "error",
            mensaje: "Tu pago fue RECHAZADO",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            authorization: null,
            img: errorImg,
          });
        } else if (status.status === "APPROVED") {
          setAlert({
            openAlert: true,
            errorAlert: "success",
            mensaje: "Tu pago ha sido APROBADO y registrado exitosamente",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: response.data.data.payment[0].receipt,
            authorization: response.data.data.payment[0].authorization,
            img: successImg,
          });
        } else if (status.status === "PENDING") {
          setAlert({
            openAlert: true,
            errorAlert: "warning",
            mensaje: "Tu pago está en estado PENDIENTE",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            authorization: null,
            img: pendingImg,
          });
        }
        submitSave(paymentTransaction.id, response.data.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const submitSave = async (id, data) => {
    const dataValue = {
      responseTransaction: JSON.stringify(data),
      status:
        data.status.status === "APPROVED"
          ? 1
          : data.status.status === "REJECTED"
          ? 0
          : 3,
    };

    try {
      const response = await axios.put(
        `${urlServices}payment-transaction/${id}`,
        dataValue
      );
      if (response.status === 200) {
        await sendMail(data);

        if (data.status.status === "APPROVED") {
          await updateStatusLink();
          await sendMailClientHost(data);
        }

        setLoader(false);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const updateStatusLink = async () => {
    try {
      const response = await axios.put(
        `${urlServices}payment-link/update-transaction/${rows.id}`,
        { status: 3 }
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error);
    }
  };

  const sendMail = async (transaccion) => {
    try {
      const values = {
        data: JSON.stringify(getDataValue()),
        status: transaccion.status.status,
        // reference: transaccion.request.payment.reference,
        reference: paymentTransactionStripe.reference,
        date: Moment(transaccion.status.date).format("DD-MM-YYYY"),
        receipt: transaccion.payment ? transaccion.payment[0]?.receipt : null,
        authorization: transaccion.payment
          ? transaccion.payment[0]?.authorization
          : null,
      };

      const response = await axios.post(
        `${urlServices}payment-link/mail-transaction`,
        values
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error);
    }
  };

  const sendMailClientHost = async (transaccion) => {
    try {
      const values = {
        data: JSON.stringify(getDataValue()),
        status: transaccion.status.status,
        //reference: transaccion.request.payment.reference,
        reference: paymentTransactionStripe.reference,
        date: Moment(transaccion.status.date).format("DD-MM-YYYY"),
        receipt: transaccion.payment ? transaccion.payment[0]?.receipt : null,
        authorization: transaccion.payment
          ? transaccion.payment[0]?.authorization
          : null,
      };

      const response = await axios.post(
        `${urlServices}payment-link/mail-transaction-client-host`,
        values
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error);
    }
  };

  const submitAccept = () => {
    let date = JSON.stringify({
      status: "accept",
      date: Moment().format("DD-MM-YYYY"),
    });

    submitAcceptSave("acceptTerms", date);
    setAccept(true);
    processPayment();
  };

  const handleChangeCheckbox = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const handleCloseFrequentQuestion = () => {
    setOpenFrequentQuestion(false);
  };

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  // Función para crear pago con Stripe
  const createStripePayment = async () => {
    setStripeLoading(true);
    try {
      const dataValue = getDataValue();

      const response = await axios.post(
        `${urlServices}stripe/create-payment`,
        dataValue
      );

      setPaymentTransactionStripe(response.data);
      setStripeClientSecret(response.data.clientSecret);
      setShowStripeForm(true);
    } catch (error) {
      console.error("Error creating Stripe payment:", error);
      setMensageSystem("Error al crear el pago con Stripe");
      setError(true);
    } finally {
      setStripeLoading(false);
    }
  };

  // Función para manejar éxito de pago con Stripe
  const handleStripeCancel = () => async () => {
    try {
      setShowStripeForm(false);

      const data = {
        requestId: paymentTransactionStripe.paymentIntentId,
        status: {
          status: "REJECTED",
          message: "La petición ha sido cancelada por el usuario",
          date: Moment().format("YYYY-MM-DD HH:mm:ss"),
        },
      };

      await submitSave(paymentTransactionStripe?.paymentTransaction?.id, data);
      setShowStripeForm(false);
    } catch (error) {
      console.error("Error handling Stripe cancel:", error);
    }
  };

  // Función para manejar pago con Stripe
  const handleStripeSuccess = async (values) => {
    try {
      setShowStripeForm(false);
      setOpenPay(true);
      setAlert({
        openAlert: true,
        errorAlert: "success",
        mensaje: "Tu pago ha sido APROBADO y registrado exitosamente",
        date: Moment(values.created).format("DD-MM-YYYY"),
        reference: paymentTransactionStripe.reference,
        price: values.amount,
        receipt: values.paymentIntentId,
        img: successImg,
      });

      const data = {
        requestId: paymentTransactionStripe.paymentIntentId,
        status: {
          status: "APPROVED",
          message: "La petición ha sido aprobada exitosamente",
          date: Moment(values.created).format("YYYY-MM-DD HH:mm:ss"),
        },
        paymentMethod: values.paymentMethod,
        price: values.amount,
        currency: values.currency,
      };

      submitSave(paymentTransactionStripe?.paymentTransaction?.id, data);
      // await RowsDatas();
    } catch (error) {
      console.error("Error handling Stripe success:", error);
    }
  };

  // Procesar el pago según el método seleccionado
  const processPayment = () => {
    if (paymentMethod === "stripe") {
      createStripePayment();
    } else if (paymentMethod === "placetopay") {
      createPay();
    }
  };

  // Manejar cambio de método de pago
  const handlePaymentMethodChange = (methodId) => {
    setPaymentMethod(methodId);
  };

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  return (
    <div style={{ background: "#F3F3F3", height: "145vh" }}>
      <AppBarStyle position="static">
        <Toolbar sx={{ minHeight: "50px !important" }}>
          <div
            className={classes.titleCardFilter}
            style={{ fontSize: 18, marginLeft: 30 }}
          >
            {rows && rows.client.companyName}
          </div>
        </Toolbar>
      </AppBarStyle>
      <center>
        <Grid
          container
          spacing={2}
          // className={classes.containerProfile}
          sx={{ width: "100%", margin: "20px 0 50px 8px" }}
        >
          <Grid item xs={12} sm={12}>
            {error && <Alert severity="error">{mensageSystem}</Alert>}
          </Grid>
          {error ? (
            <Grid item xs={12} sm={12} sx={{ my: 15 }}>
              <center>
                <DoDisturbOnOutlined sx={{ fontSize: 46, color: "#ccc" }} />
                <br></br>
                <b
                  style={{
                    fontSize: 18,
                    margin: "5px 0 70px 0",
                    color: "#ccc",
                  }}
                >
                  No hay registros para mostrar
                </b>
              </center>
            </Grid>
          ) : Loader ? (
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  alt="loaderGif"
                  src={loaderGif}
                  style={{ width: 60, margin: "20% 0" }}
                />
              </center>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} sm={12}>
                <Grid
                  container
                  spacing={2}
                  className={classes.containerProfile}
                  sx={{ paddingBottom: 8, minWidth: 450, width: 440 }}
                >
                   <Grid item xs={12} sm={12}>
                      <center>
                      <Box
                        component="img"
                        src={logo}
                        alt="logo"
                        sx={{ width: 120}}
                      ></Box></center>
                    </Grid>                
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{ fontSize: 16, color: "#000" }}
                  >
                    <Box>
                      <b>Cliente titular: </b>
                      <br></br>
                      {`${rows.name} ${rows.lastName}`}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                          borderBottom: "1px solid #ccc",
                          mt: 1,
                          p: "18px 25px",
                          fontSize: 14,
                          color: "#000",
                        }}
                      >
                        <Box sx={{ float: "left" }}>
                          <b>Link de pago refencia: </b>{" "}
                          <span
                            style={{
                              background: "lavender",
                              padding: 5,
                              letterSpacing: 2,
                            }}
                          >
                            {rows.reference}
                          </span>
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                          p: "8px 0 8px 60px",
                          fontSize: 12,
                          borderBottom: "1px solid #ccc",
                          color: "#000",
                        }}
                      >
                        <Box sx={{ float: "left" }}>
                          <b style={{ marginRight: 10 }}>SUBTOTAL:</b>$
                          {rows.ivaSubtotal === "0.00" ? "0.00" : rows.subTotal}
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                          p: "8px 0 8px 60px",
                          fontSize: 12,
                          borderBottom: "1px solid #ccc",
                          color: "#000",
                        }}
                      >
                        <Box sx={{ float: "left" }}>
                          <b style={{ marginRight: 10 }}>SUBTOTAL 0%: </b> $
                          {rows.ivaSubtotal === "0.00" ? rows.subTotal : "0.00"}
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                          p: "8px 0 8px 60px",
                          fontSize: 12,
                          borderBottom: "1px solid #ccc",
                          color: "#000",
                        }}
                      >
                        <Box sx={{ float: "left" }}>
                          <b style={{ marginRight: 10 }}>IVA</b>$
                          {rows.ivaSubtotal === "0.00"
                            ? "0.00"
                            : rows.ivaSubtotal}
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                          borderBottom: "1px solid #ccc",
                          mt: 1,
                          p: "10px 0",
                          fontSize: 18,
                          textAlign: "center",
                          color: "#000",
                        }}
                      >
                        <b>TOTAL: </b> ${rows.total}
                      </Grid>
                      {/*<Grid item xs={12} sm={6}>
                        <center>
                          <Box
                            component="img"
                            src="https://static.placetopay.com/placetopay-logo.svg"
                            alt="paymentsCompany"
                            sx={{ width: 100, mt: 3 }}
                          ></Box>
                        </center>
                      </Grid>*/}
                      <Grid item xs={12} sm={12}>
                        <center>
                          <Box
                            component="img"
                            src={typeCard}
                            alt="franquicias"
                            sx={{ width: 200, my: 3 }}
                          ></Box>
                        </center>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{
                      color: "#000",
                      background: "#F6F6F6",
                      borderRadius: 5,
                    }}
                  >
                    <Box sx={{ p: "15px 20px" }}>
                      {/* Selección de método de pago */}
                      {/*<FormControl
                        component="fieldset"
                        sx={{ width: "100%", mb: 3 }}
                      >
                        <FormLabel
                          component="legend"
                          sx={{ mb: 2, fontWeight: "bold", textAlign: "left" }}
                        >
                          Método de pago:
                        </FormLabel>
                        <Box>
                          {paymentMethods.map((method) => (
                            <PaymentMethodOption
                              key={method.id}
                              method={method}
                              selected={paymentMethod === method.id}
                              onSelect={handlePaymentMethodChange}
                            />
                          ))}
                        </Box>
                      </FormControl>*/}

                      <Box sx={{ float: "left", fontWeight: "bold" }}>
                        <span
                          onClick={() => setOpenFrequentQuestion(true)}
                          style={{
                            fontSize: 12,
                            textTransform: "none",
                            fontFamily:
                              '"Roboto", "Helvetica", "Arial", sans-serif',
                            fontWeight: 500,
                            lineHeight: 1.75,
                            color: "#000",
                            cursor: "pointer",
                            border: "1px solid dimgrey",
                            padding: "4px 10px",
                            borderRadius: 4,
                            marginRight: 8,
                          }}
                        >
                          Terminos y condiciones - Políticas de protección de
                          datos
                        </span>
                      </Box>
                      <Box sx={{ float: "left", mt: 1 }}>
                        {!accept && (
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={state.YES_termsConditions}
                                  onChange={handleChangeCheckbox}
                                  name="YES_termsConditions"
                                />
                              }
                              label={
                                <span style={{ fontSize: 12 }}>
                                  Sí acepto los términos y condiciones.
                                </span>
                              }
                              sx={{
                                color: blackColor,
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                ml: 3,
                              }}
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={state.YES_dataProtectionPolicies}
                                  onChange={handleChangeCheckbox}
                                  name="YES_dataProtectionPolicies"
                                />
                              }
                              label={
                                <span style={{ fontSize: 12 }}>
                                  Sí acepto las políticas de protección de
                                  datos.
                                </span>
                              }
                              sx={{
                                color: blackColor,
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                ml: 3,
                              }}
                            />
                          </FormGroup>
                        )}
                        <Box
                          component="div"
                          sx={{
                            fontWeight: "bold",
                            color: "green",
                            display: accept ? "block" : "none",
                          }}
                        >
                          <img
                            src={checkbox}
                            alt="checkbox"
                            style={{ width: 15, marginRight: 10 }}
                          />{" "}
                          {"Terminos aceptados."}
                        </Box>
                      </Box>
                      <center>
                        <Box sx={{ mt: 10 }}>
                          <ButtonStyle0
                            type="submit"
                            onClick={submitAccept}
                            disabled={
                              disabledPay ||
                              stripeLoading ||
                              (!accept &&
                                (!state.YES_termsConditions ||
                                  !state.YES_dataProtectionPolicies))
                            }
                          >
                            {stripeLoading
                              ? "Procesando..."
                              : `Pagar $${rows.total}`}
                          </ButtonStyle0>
                        </Box>

                        {/* Formulario de Stripe */}
                        <StripePaymentForm
                          open={showStripeForm}
                          onClose={handleStripeCancel()}
                          clientSecret={stripeClientSecret}
                          amount={rows?.total}
                          onSuccess={handleStripeSuccess}
                          onError={(error) => {
                            console.error("Stripe payment error:", error);
                            setMensageSystem("Error en el pago con Stripe");
                            setError(true);
                          }}
                        />
                      </center>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </center>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={Loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Resto del código del diálogo de resultados */}
      {OpenPay && (
        <Dialog
          fullWidth
          maxWidth="md"
          open={OpenPay}
          keepMounted
          scroll="body"
          PaperProps={{
            sx: {
              borderRadius: 6,
            },
          }}
        >
          <DialogContent dividers className={classes.styleDialogContent}>
            <Grid
              container
              spacing={2}
              className={classes.containerProfile}
              sx={{ paddingBottom: 8 }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={alert.img}
                  alt="type"
                  style={{ width: 200, marginBottom: 20 }}
                />
                <Alert
                  severity={
                    alert.errorAlert === "success" ? "success" : "error"
                  }
                  icon={false}
                  sx={{ fontSize: 20 }}
                >
                  {alert.mensaje}
                </Alert>
                <br></br>
                <List sx={style}>
                  <ListItem>
                    <Grid container sx={{ color: "#000" }}>
                      <Grid item xs={6} sm={6}>
                        <b style={{ marginRight: 50 }}>Fecha</b>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <span style={{ float: "right" }}>
                          <ListItemText primary={alert.date} />
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />
                  <ListItem>
                    <Grid container sx={{ color: "#000" }}>
                      <Grid item xs={6} sm={6}>
                        <b style={{ marginRight: 50 }}>Referencia</b>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <span style={{ float: "right" }}>
                          <ListItemText primary={alert.reference} />
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />
                  <ListItem>
                    <Grid container sx={{ color: "#000" }}>
                      <Grid item xs={6} sm={6}>
                        <b style={{ marginRight: 50 }}>Valor</b>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <span style={{ float: "right" }}>
                          <ListItemText
                            primary={"$" + parseFloat(alert.price).toFixed(2)}
                          />
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {/*alert.receipt && (
                    <>
                      <Divider component="li" />
                      <ListItem>
                        <Grid container sx={{ color: "#000" }}>
                          <Grid item xs={6} sm={6}>
                            <b style={{ marginRight: 50 }}>Recibo</b>
                          </Grid>
                          <Grid item xs={6} sm={6}>
                            <span style={{ float: "right" }}>
                              <ListItemText primary={alert.receipt} />
                            </span>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <Divider component="li" />
                      <ListItem>
                        <Grid container sx={{ color: "#000" }}>
                          <Grid item xs={6} sm={6}>
                            <b style={{ marginRight: 50 }}>Autorización</b>
                          </Grid>
                          <Grid item xs={6} sm={6}>
                            <span style={{ float: "right" }}>
                              <ListItemText primary={alert.authorization} />
                            </span>
                          </Grid>
                        </Grid>
                      </ListItem>
                    </>
                  )*/}
                </List>
              </Grid>
              {/*<Grid item xs={12} sm={12} sx={{ paddingTop: 15 }}>
                  <center>
                    <ButtonStyle0 href="https://usamebpo.com/">
                      Salir de la ventana
                    </ButtonStyle0>
                  </center>
                </Grid>*/}
            </Grid>
          </DialogContent>
        </Dialog>
      )}

      {openFrequentQuestion && (
        <FrequentQuestions
          open={openFrequentQuestion}
          exit={handleCloseFrequentQuestion}
        />
      )}
    </div>
  );
}
